<template>
<div class="container-fluid mt-3">
  <h2>Prozess-Verlauf</h2>
  <div class="row mt-3">
    <div class="col-md">
      <h4>Allgemein</h4>
      <table class="table table-striped">
        <tbody>
          <tr>
            <td><b>ID</b></td><td>{{ procdata.id }}</td>
          </tr>
          <tr>
            <td><b>Key</b></td><td>{{ procdata.key }}</td>
          </tr>
          <tr>
            <td><b>Start</b></td><td>{{ procdata.start }}</td>
          </tr>
          <tr>
            <td><b>Ende</b></td><td>{{ procdata.end }}</td>
          </tr>
          <tr>
            <td><b>Definition</b></td>
            <td><router-link :to="'/workflows/definitions/' + procdata.procdef.did">{{ procdata.procdef.did }}</router-link></td>
          </tr>
          <tr v-if="procdata.end == ''">
            <td><b>Abbruch:</b></td><td><button @click="stopProcess" class="btn btn-danger">Abbrechen</button></td>
          </tr>
          <tr v-if="procdata.deleted">
            <td>Abbruch:</td>
            <td><span class="alert alert-danger">{{ procdata.deleted }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md">
      <b-tabs v-model="tabidx">
        <b-tab title="Vorschau">
          <DynamicDataView :html="preview" :data="params"/>
        </b-tab>
        <b-tab title="Daten">
          <JsonViewer :data="params.values" :root="true"/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
  <div class="row mt-3">
    <h3>Aufgaben-Verlauf</h3>
    <b-table striped hover :items="proctasks" :fields="taskfields"></b-table>
  </div>
  <div class="row mt-3">
    <h3>Prozess Diagramm</h3>
    <img v-if="procdata.procdef.did" style="max-width:100%;" :src="baseurl + 'rest/wf/process/diagram?id=' + encodeURIComponent(procdata.procdef.did)"/>
  </div>
  <div class="row mt-3">
    <h3>Chat Bot Nachrichten</h3>
    <div id="chattable">

    </div>
  </div>
</div>
</template>

<script>
import config from '@/modules/config.js'
import workflows from '@/modules/workflows.js'
import JsonViewer from '@/components/JsonViewer.vue'
import DynamicDataView from '@/components/DynamicDataView.vue'

export default {
  name: 'ProcessHistoryEntry',
  components: {
    JsonViewer,
    DynamicDataView,
  },
  data() {
    return {
      tabidx: 1,
      procid: -1,
      procdata: { procdef: {}},
      proctasks: [],
      params: {},
      baseurl: config.baseUrl,
      preview: '',
      taskfields: [
        { label: 'ID', key: 'id' },
        { label: 'Name' , key: 'name' },
        { label: 'Mitarbeiter' , key: 'assignee' },
        { label: 'Start', key: 'start' },
        { label: 'Ende', key: 'end' },
        { label: 'Task-ID' , key: 'activityid' },
        { label: 'Type' , key: 'type' },
      ]
    }
  },
  created: function() {
    this.procid = this.$route.params.id;
    this.fetchData();
  },
  methods: {
    stopProcess: function() {
      var msg = prompt('Geben Sie zum Stoppen des Prozesses ein kurze Hinweis ein:');
      if (msg !== '' && msg !== null) {
        console.log('stop it: ' + this.procid);
        var self = this;
        workflows.killproc(this,this.procid,msg,function() {
          self.$bvToast.toast('Prozess wurde angehalten.',{title:'Prozessablauf',variant: 'success'})
          self.fetchData();
        });
      }
    },
    fetchPreview() {
      var self = this;
      workflows.loadresultpreview(this,this.procdata.key,function(data) {
        console.log(data);
        self.preview = data.html;
        self.tabidx = 0;
      })
    },
    fetchData: function() {
      var self = this;
      workflows.historyEntry(this,this.procid,function(data) {
        self.procdata = data;
        if (data.variables)
          self.params = { values: data.variables };
        else
          self.params = { values: {} };
        self.fetchPreview();
      })
      workflows.historyTasks(this,this.procid,function(data) {
        self.proctasks = data;
      })
    }
  }
}
</script>
